// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8144f09b","455":"e9013ae6","977":"732026ec"}[chunkId] + ".chunk.js";
};